import axios from '@/libs/axios'

export class DialyReportServices {


  


    static async getReportNotifications() {
      return new Promise((resolve, reject) => {
        axios.get(`user/getReportNotifications`)
          .then(res => resolve(res.data))
          .catch(reason => reject(reason.response))
      })
    
    
    
    }


}
  